import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      YFT!
    </div>
  );
}

export default App;
